import * as Yup from 'yup'
import {ID, Response} from '../../../../../../_metronic/helpers'
import { FieldTProps } from '../../../../../../_component/Form'
export type SchoolModel = {
  id?: ID
  name?: string
  url?: string
  registration_date?: Date
  address?: string
  phone?: string
  email?: string
  currency?: string
  currency_symbol?: string
  logo?: string
  principal_signature?: string
  fax?: string
  zoom_api_key?: string
  zoom_secret?: string
  enable_frontend?: boolean
  enable_online_admission?: boolean
  final_result_type?: string
  average_result_type?: Array<string> | undefined
  language?: string
  about_text?: string
  about_image?: string
  google_map?: string
  facebook_url?: string
  twitter_url?: string
  linkedin_url?: string
  youtube_url?: string
  instagram_url?: string
  status?: boolean
  created_at?: Date
  updated_at?: Date
  deleted_at?: Date
  created_by?: string
  updated_by?: string
  school_id?: string
  theme_id?: string
  logo_to_upload?: File
  principal_signature_to_upload?: File
  school_marks?: Mark[]
  school_psychomotors?: Psychomotor[]
}
export type Mark = {name: string; value: number; id?: string}
export type Psychomotor = {name: string; id?: string}
export type SchoolsQueryResponse = Response<Array<SchoolModel>>

export const initialSchool: SchoolModel = {
  name: '',
  url: '',
  address: '',
  phone: '',
  email: '',
  currency: '',
  language: '',
  currency_symbol: '',
  logo: '',
  fax: '',
  zoom_api_key: '',
  zoom_secret: '',
  final_result_type: '',
  average_result_type: undefined,
  about_text: '',
  about_image: '',
  google_map: '',
  facebook_url: '',
  twitter_url: '',
  linkedin_url: '',
  youtube_url: '',
  instagram_url: '',
  theme_id: '',
  status: true,
  school_marks: [
    {name: 'CA1', value: 30},
    {name: 'CA2', value: 30},
    {name: 'Exam', value: 40},
  ],
  school_psychomotors: [],
}

export const schoolSchemas = [
  Yup.object().shape({
    name: Yup.string().required().label('School Name'),
    url: Yup.string(),
    address: Yup.string().required().label('School Address'),
    phone: Yup.string().required().label('School Phone Number'),
    email: Yup.string().required().label('School Email'),
    currency: Yup.string().required().label('Currency'),
    logo: Yup.string(),
    fax: Yup.string(),
  }),
  Yup.object().shape({
    enable_frontend: Yup.string(),
    enable_online_admission: Yup.string(),
    language: Yup.string().required().label('Language'),
    google_map: Yup.string().label('Google Map URL'),
  }),
  Yup.object().shape({
    final_result_type: Yup.string().required().label('Final Result Type'),
    average_result_type: Yup.array().when('final_result_type', {
      is: 'Average',
      then: Yup.array().required().label('Average Result Cummulation'),
    }),
  }),
  Yup.object().shape({}),
  Yup.object().shape({
    zoom_api_key: Yup.string(),
    zoom_secret: Yup.string(),
    google_map: Yup.string(),
    facebook_url: Yup.string(),
    twitter_url: Yup.string(),
    linkedin_url: Yup.string(),
    youtube_url: Yup.string(),
    instagram_url: Yup.string(),
  }),
]
export const fields: (formik?: any) => FieldTProps[] = (formik = {values: {}}) => [
  {
    title: 'School Info',
    fields: [
      {name: 'name', label: 'Name', required: true, full: false, table: true, sortable: true},
      {
        name: 'url',
        label: 'School URL',
        type: 'text',
        required: false,
        full: false,
        sortable: true,
        table: false,
      },

      {
        name: 'phone',
        label: 'Phone',
        type: 'text',
        required: true,
        full: false,
        sortable: true,
        table: true,
      },
      {
        name: 'email',
        label: 'School Email Address',
        type: 'email',
        required: true,
        full: false,
        sortable: true,
        table: true,
      },
      {
        name: 'currency',
        label: 'Currency',
        type: 'select',
        options: [
          {label: 'NGN', value: 'NGN'},
          {label: 'USD', value: 'USD'},
          {label: 'EUR', value: 'EUR'},
          {label: 'GBP', value: 'GBP'},
          {label: 'KES', value: 'KES'},
          {label: 'GHS', value: 'GHS'},
        ],
        required: true,
        full: false,
        sortable: true,
        table: true,
      },
      {
        name: 'fax',
        label: 'Fax Number',
        type: 'text',
        required: false,
        sortable: true,
      },
      {
        name: 'logo',
        label: 'Logo Upload',
        type: 'image',
        full: false,
        sortable: true,
        table: false,
      },
      {
        name: 'status',
        label: 'Status',
        type: 'switch',
        full: false,
        // table: true,
        sortable: true,
      },
      {
        name: 'address',
        label: 'School Address',
        type: 'textarea',
        required: true,
        full: true,
        sortable: true,
      },
    ],
  },
  {
    title: 'School Settings',
    fields: [
      {
        name: 'enable_frontend',
        label: 'Enable Frontend Access?',
        type: 'switch',
        sortable: true,
        full: false,
      },
      {
        name: 'enable_online_admission',
        label: 'Enable Online Admission?',
        type: 'switch',
        sortable: true,
        full: false,
      },
      {
        name: 'language',
        label: 'Language',
        type: 'select',
        options: [
          {label: 'English', value: 'English'},
          {label: 'French', value: 'French'},
        ],
        required: true,
        full: false,
        sortable: true,
        table: false,
      },
      {
        name: 'principal_signature',
        label: `Pricipal's Signature`,
        type: 'image',
        full: false,
        sortable: true,
      },
      {
        name: 'google_map',
        label: 'Google Map URL',
        type: 'link',
        required: false,
        full: true,
        sortable: true,
      },
    ],
  },
  {
    title: 'Exam Settings',
    fields: [
      {
        name: 'final_result_type',
        label: 'Final Result Type',
        type: 'select',
        options: [
          {label: 'Only Final Exam', value: 'Final'},
          {label: 'Exam Cummulative Average', value: 'Average'},
        ],
        required: true,
        sortable: true,
      },
      ...(formik.values?.final_result_type === 'Average'
        ? [
            {
              name: 'average_result_type',
              label: 'Result Types',
              type: 'checkbox' as const,
              viewNme: 'exam.title',
              optionsQuery: {
                queryKey: ['exam', 'filter={"status":true}'],
                enabled: true,
                name: 'title',
              },
              table: false,
              sortable: false,
              full: false,
            },
          ]
        : []),

      {
        name: 'school_marks',
        label: 'Mark Settings',
        type: 'multi-input',
        full: true,
        fields: [
          {
            name: 'name',
            label: 'Title',
            type: 'text',
            required: true,
          },
          {
            name: 'value',
            label: 'Value (%)',
            type: 'number',
            required: true,
          },
        ],
      },
    ],
  },
  {
    title: 'Psychomotor Settings',
    fields: [
      {
        name: 'school_psychomotors',
        label: 'Psychomotor Settings',
        type: 'multi-input',
        full: true,
        sortable: true,
        fields: [
          {
            name: 'name',
            label: 'Name',
            type: 'text',
            required: true,
            full: false,
          },
        ],
      },
    ],
  },
  {
    title: 'Social Media Links',
    fields: [
      {
        name: 'zoom_api_key',
        label: 'Zoom API Key',
        type: 'link',
        full: false,
        sortable: true,
      },
      {
        name: 'zoom_secret',
        label: 'Zoom Secret Key',
        type: 'link',
        full: false,
        sortable: true,
      },
      {
        name: 'facebook_url',
        label: 'Facebook URL',
        type: 'link',
        full: false,
        sortable: true,
      },
      {
        name: 'twitter_url',
        label: 'X URL',
        type: 'link',
        full: false,
        sortable: true,
      },
      {
        name: 'linkedin_url',
        label: 'LinkedIn URL',
        type: 'link',
        full: false,
        sortable: true,
      },
      {
        name: 'youtube_url',
        label: 'YouTube URL',
        type: 'link',
        full: false,
        sortable: true,
      },
      {
        name: 'instagram_url',
        label: 'Instagram URL',
        type: 'link',
        full: false,
        sortable: true,
      },
    ],
  },
]